<template>
  <b-col v-if="openPlan" class="pricing-info-container justify-content-center">
    <div class="d-flex flex-column">
      <div class="title">{{ openPlan.name }}</div>
      <div class="subtitle">{{ openPlan.description }}</div>
      <div class="frequency">{{ chargeFrequencyText }}</div>
      <div class="divider d-none d-md-block"></div>
      <p class="contact-text d-none d-md-block" @click="needHelp">
        {{ $t('purchase.price.info.contactUs') }}
      </p>
      <div class="divider d-none d-md-block"></div>
      <div class="gray-text terms-and-cond d-none d-md-block">
        <p v-if="openPlan.isMonthlyAnnualCommitment">
          {{ $t('purchase.price.info.subscriptionRenewMonthlyAnnualCommitment') }}
        </p>
        <p v-else>
          {{ $t('purchase.price.info.subscriptionRenew') }}
        </p>
        <p>
          <span class="gray-text">{{ $t('purchase.price.info.byPurchasing') }}</span>
          <nuxt-link :to="$trailingSlash(localePath('terms-and-conditions'))">{{
            $t('purchase.price.info.termsAndConditions')
          }}</nuxt-link>
        </p>
      </div>

      <div class="divider"></div>

      <div v-if="openPlan.hasFreeTrial && !freeTrialUsed">
        <div class="gray-text terms-and-cond">
          <p>
            {{ $t('purchase.price.info.freeTrialDetail') }}
          </p>
        </div>

        <div class="divider"></div>
      </div>

      <div class="flex justify-content-between m-0 row">
        <div>
          <div class="total-due">{{ $t('purchase.price.info.totalDue') }}</div>
          <p v-if="openPlan.hasFreeTrial && !freeTrialUsed" class="free-trial gray-text">
            {{ $t('purchase.price.info.freeTrial') }} ${{ openPlan.originalCost }}
          </p>
        </div>
        <div class="price">
          <span class="currency">$</span
          ><span class="amount">{{
            openPlan.hasFreeTrial && !freeTrialUsed ? 0 : openPlan.originalCost
          }}</span>
        </div>
      </div>
    </div>
  </b-col>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState('plans', ['openPlan']),
    ...mapState('payments', ['freeTrialUsed']),
    chargeFrequencyText() {
      const frequency = this.openPlan.chargeFrecuency;
      return frequency === 'ANNUALLY'
        ? this.$t('purchase.price.info.billedAnnually')
        : frequency === 'MONTHLY' || frequency === 'MONTHLY_ANNUAL_COMMITMENT'
        ? this.$t('purchase.price.info.billedMonthly')
        : frequency === 'LIFETIME'
        ? this.$t('purchase.price.info.billedOneTime')
        : '';
    }
  },
  methods: {
    needHelp() {
      try {
        window.$crisp.push(['do', 'chat:open']);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pricing-info-container {
  padding: 15px 25px;
  @include lg {
    padding: 30px;
  }
  .title {
    font-weight: 500;
    font-size: 25px;
    margin-bottom: 15px;
  }
  .subtitle {
    font-size: 13px;
  }
  .frequency {
    font-size: 12px;
    margin-bottom: 20px;
    margin-top: 15px;
    color: #515151;
  }
  .contact-text {
    font-size: 13px;
  }
  .divider {
    border-top: 2px solid #f1f1f1;
    padding: 10px 0;
  }
  .gray-text {
    color: #515151;
  }
  .terms-and-cond {
    font-size: 12px;
  }
  .price {
    font-size: 15px;
    text-align: right;
  }
  .total-due {
    font-size: 15px;
    display: flex;
    align-items: center;
  }
  .amount {
    font-weight: 500;
  }
  .currency {
    font-size: 12px;
  }

  .free-trial {
    font-size: 13px;
  }
}
</style>
